import { PartialBreakpointMap } from '@/hooks/use-breakpoints';

import { CarouselItem, CarouselPerPage } from '../types';

type CarouselPageProps = {
  items: CarouselItem[];
  perPage: CarouselPerPage | PartialBreakpointMap<CarouselPerPage>;
};

export default function CarouselPage(props: CarouselPageProps) {
  return (
    <div
      className='z-0 mx-auto grid gap-4 scroll-smooth sm:max-w-none sm:gap-6'
      style={{
        gridTemplateColumns: `repeat(${props.perPage}, 1fr)`,
      }}
    >
      {props.items.map((item) => {
        return (
          <div
            className='flex select-none items-stretch justify-center sm:pb-5'
            key={item.id}
          >
            {item.component}
          </div>
        );
      })}
    </div>
  );
}
